@if (mobile()) {
    @if (actions().length) {
        <button
            #moreActions
            data-viewer-actions-toggle
            qpxButton
            matIconButton
            size="sm"
            context="secondary"
            tone="muted"
            aria-label="More viewer actions"
            [matMenuTriggerFor]="actionsMenu"
        >
            <ng-icon qpx name="lucideEllipsisVertical" />
        </button>
        <mat-menu
            #actionsMenu="matMenu"
            aria-label="More viewer actions"
            yPosition="above"
        >
            @for (action of actions(); track action.id) {
                <button
                    mat-menu-item
                    [disabled]="action.disabled ?? false"
                    [attr.aria-label]="action.ariaLabel ?? action.label"
                    [attr.aria-disabled]="action.ariaDisabled ? 'true' : null"
                    [attr.aria-haspopup]="action.hasPopup ?? null"
                    [attr.aria-expanded]="action.expanded ?? null"
                    (click)="selectOverflowAction(action, $event)"
                >
                    <ng-icon
                        qpx
                        matMenuItemIcon
                        size="sm"
                        [name]="action.icon"
                    />
                    <span>{{ action.label }}</span>
                </button>
            }
        </mat-menu>
    }
} @else {
    @for (action of actions(); track action.id) {
        <button
            qpxButton
            matIconButton
            [context]="action.context ?? 'secondary'"
            [tone]="action.tone ?? (action.context ? 'default' : 'muted')"
            [attr.aria-label]="action.ariaLabel ?? action.label"
            [attr.aria-haspopup]="action.hasPopup ?? null"
            [attr.aria-disabled]="action.ariaDisabled ? 'true' : null"
            [attr.aria-expanded]="
                action.expanded === undefined ? null : action.expanded
            "
            [disabled]="action.disabled ?? false"
            [qpxTooltip]="action.tooltip ?? action.label"
            matTooltipPosition="below"
            (click)="
                action.onSelect({
                    origin: $event.currentTarget,
                    event: $event,
                })
            "
        >
            <ng-icon qpx [name]="action.icon" />
        </button>
    }
}
